import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ApiContext from '../../contexts/ApiContext';

interface Props {
  invoiceNumber: string;
  enabled?: boolean;
}

export default function useGetInvoiceChangeAscriptionIsAllowedQuery({
  invoiceNumber,
  enabled,
}: Props): UseQueryResult<boolean> {
  const { invoiceApi } = useContext(ApiContext);

  return useQuery({
    queryKey: ['isChangeAscriptionInvoiceAllowed', invoiceNumber, enabled],
    queryFn: async () => {
      if (!invoiceApi) {
        throw new Error('invoiceApi is not available');
      }

      const data = await invoiceApi.isChangeAscriptionInvoiceAllowed(invoiceNumber);
      return data;
    },
    enabled,
  });
}
